// **********************************************************
// Open Header Search
// **********************************************************

const headerSearchInput = document.querySelector('.header-search input');

attachEvent('.header-search__trigger', 'click', (ev) => {
  const isOpen = document.body.classList.contains('is-open-search');
  document.body.classList.remove('is-open-menu');
  document.body.classList.toggle('is-open-search', !isOpen);
  setTimeout(() => {
    if (isOpen) {
      headerSearchInput.blur();
    } else {
      headerSearchInput.focus();
    }
  }, 300);
  ev.preventDefault();
});

// Close Search Bar When Escape Key Press
if (headerSearchInput) {
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      document.body.classList.remove('is-open-search');
      headerSearchInput.blur();
    }
  });
}
